import { i18n } from '@/i18n';

/** 页面标题 */
export const PAGE_TITLE = i18n('商戶禮遇');

/** 页面链接 */
export const PAGE_URL = 'https://prom.wechatpay.com.hk/merchant-channel/index.shtml';

export enum ERouterName {
  /** 首页 */
  home = 'home',
  /** 单张券页 */
  coupon = 'coupon',
  thirdmpredirect = 'thirdmpredirect',
}

